import React, { useEffect } from "react";
import "../styles/plan.css";
import Navbar from "../components/common/Navbar";
import HeroPlan from "../components/plan/HeroPlan";
import PlanContact from "../components/plan/PlanContact";

const EventPlanPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top
  }, []);
  return (
    <div>
      <Navbar />
      <HeroPlan />
      <PlanContact />
    </div>
  );
};

export default EventPlanPage;
